import { useCompoundBody } from "@react-three/cannon"
import { useGLTF } from "@react-three/drei"
import { useRef } from "react"
import { Group, Material, Mesh } from "three"
import { ObjectProps, useDragConstraint } from "../utils"
import { asset } from "../../consts"
import type { GLTF } from "three-stdlib/loaders/GLTFLoader";

interface ComputerKeyboardGLTF extends GLTF {
  materials: {
    default: Material
    Liquid: Material
  }
  nodes: {
    'Keyboard': Mesh
  }
}
export default ({position, rotation}: ObjectProps) => {
  const { nodes, materials } = useGLTF(asset('/models/ComputerKeyboard.glb')) as any as ComputerKeyboardGLTF
  const [ref] = useCompoundBody(() => ({
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [3.7, 0.2, 1.3], mass: 10, position: [0, 0.1, 0.4], type: 'Box' },
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind} dispose={null}>
      <group scale={[0.04, 0.04, 0.04]} >
        <mesh
          receiveShadow
          castShadow
          material={materials.default}
          geometry={nodes['Keyboard'].geometry}
        />
      </group>
    </group>
  );
};
